export default "__VITE_ASSET__ekpzgh3C__"